import { LocationNumbersService } from '../../../services'

const checkTollFreeVerification = async function ({ commit, state, getters }, payload) {
  const { companyId, locationId, tollFreePhoneNumberSID } = payload

  const existingResponse = state.tollFreeStatus[tollFreePhoneNumberSID]

  if (existingResponse && Object.keys(existingResponse ?? {})?.length)
    return Promise.resolve(existingResponse)

  try {
    const res = (await LocationNumbersService.getTollFreeVerificationStatus(
      companyId,
      locationId,
      tollFreePhoneNumberSID
    )) as any

    const requestData = res?.data?.tollFreeRequest

    commit('setTollFreeDataAt', {
      sid: tollFreePhoneNumberSID ?? requestData?.tollfreePhoneNumberSid,
      tollFreeRequest: requestData,
    })

    commit(
      'setPhoneNumbers',
      getters.getCorrectedPhoneNumbers(state.phoneNumbers)
      )

    return Promise.resolve(requestData)
  } catch (error) {
    commit('setTollFreeDataAt', {
      sid: tollFreePhoneNumberSID,
      tollFreeRequest: null,
    })
    return Promise.reject(error)
  }
}

export default checkTollFreeVerification
